import { ROMSChart } from '@/features/charts/ROMSChart';
import { TrafficDetailKPIMetrics } from '@/features/TrafficDetailKPIMetrics';

import CampaignOpportunityInfluenceChartTable from './CampaignOpportunityInfluenceChartTable';
import CampaignTotalVisitsChart from './CampaignTotalVisitsChart';
import CampaignVisitEfficiencyChart from './CampaignVisitEfficiencyChart';

type Props = {
  campaignName?: string;
  campaignIds?: string[];
  isLoading?: boolean;
};

const CampaignDetailContent = ({ campaignName, campaignIds, isLoading }: Props) => {
  return (
    <div className="flex w-full flex-col gap-6">
      <TrafficDetailKPIMetrics
        objectType="campaign"
        campaignIds={campaignIds}
        isLoading={isLoading}
      />
      <CampaignTotalVisitsChart campaignIds={campaignIds} isLoading={isLoading} />
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <div>
          <ROMSChart
            objectName={campaignName || ''}
            campaignIds={campaignIds}
            isLoading={isLoading}
          />
        </div>
        <div>
          <CampaignVisitEfficiencyChart campaignIds={campaignIds} isLoading={isLoading} />
        </div>
      </div>
      <CampaignOpportunityInfluenceChartTable campaignIds={campaignIds} isLoading={isLoading} />
    </div>
  );
};

export default CampaignDetailContent;
